import { cn } from '@/utils/classname';
import { SVGProps } from 'react';
import { fill, stroke } from './classNames';

export const LayersIcon = ({
  isActive,
  className,
  ...props
}: { isActive: boolean } & SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="21"
      viewBox="0 0 21 21"
      width="21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={cn('group', className)}
    >
      <path
        className={fill(isActive)}
        d="M9.22426 9.03792L1 5.82275L11.1909 1L19.3258 4.21517L9.22426 9.03792Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.685"
      />
      <path
        className={stroke(isActive)}
        d="M19.3258 7.73096L9.22426 12.4532L1 9.23807"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.685"
      />
      <path
        className={stroke(isActive)}
        d="M19.3258 11.1309L9.22426 15.8531L1 12.7384"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.685"
      />
      <path
        className={stroke(isActive)}
        d="M19.3258 14.4307L9.22426 19.2534L1 16.0382"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.685"
      />
    </svg>
  );
};
